<template>
  <w-flex justify-center align-center v-if="($zutil.role('Penternak') || $zutil.role('Pentadbir Sistem'))&& $page.props.auth.user.id == data.user_id">
    <div class="w-card__content content-hardcode">
      <w-flex class="mt3">
        <div class="xs11 text-right" >
          <inertia-link :href="$route('ternakan.form',0)+'?premis_id='+data.id" class="w-button green--bg  w-button--dark size--md  ml1"> 
             <w-icon class="mr1">fal fa-plus</w-icon> Tambah
          </inertia-link>
        </div>
      </w-flex>
    </div>
  </w-flex>
  <div class="w-table w-table--wrap">
    <div class="w-table__scroll-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Jenis Ternakan</th>
          <th class="w-table__header  text-left">No Pendaftaran</th>
          <th class="w-table__header  text-left">ID | Nama Ternakan</th>
          <th class="w-table__header  text-left">Baka</th>
          <th class="w-table__header  text-left">Jurusan Ternakan</th>
          <th class="w-table__header  text-left">Jantina</th>
          <th class="w-table__header  text-left">Tarikh lahir</th>
          <th class="w-table__header  text-left">Status</th>
          <th class="w-table__header  text-left"  width="1%">Tindakan</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas" >
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" style="padding-top:10px">{{ind+1}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px" >{{dt.ternakan}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.kode}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.id_ternakan}} | {{dt.nama}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.baka}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.lkp_jurusan}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.jantina}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{$zutil.dateformat(dt.tarikh_lahir)}}</td>
            <td class="w-table__cell text-left" style="padding-top:10px">{{dt.status}}</td>
            <td class="w-table__cell text-left" >
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                       <inertia-link :href="$route('daftar.ternakan.show',dt.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                        <w-icon md class="mr2">fal fa-eye</w-icon>
                     </inertia-link>
                </template>
               PAPAR
            </w-tooltip>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</div>


</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      datas : [],
      
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'premis/ternakan/'+this.data.id, {}).then(res => {
        this.datas = res
      })
    },
    
  },
      
  mounted() {
    this.getData()
    
  }
}
      

</script>  
